import { defineStore } from 'pinia';
import { ref } from "vue";
import { useRouter } from "vue-router";
import axios from 'axios';
import { endpoint } from "@/remote/utils.js";

export const useAuthStore = defineStore(
  'auth',
  () => {
    const polledAndLoggedIn = ref(false);
    const user = ref(null);
    const returnUrl = ref('');

    const router = useRouter();

    function isSuperAdmin(user) {
      return user['is_superuser'] || user['is_staff'];
    }

    async function isLogged(routeComposable) {
      if (!polledAndLoggedIn.value) {
        await pollIfLogged(routeComposable);
      }
      return user.value !== null;
    }

    async function login(username, password) {
      const response = await axios.post(endpoint('public/1/auth/login/'), {
        username: username,
        password: password
      }, {
        withCredentials: true
      });

      if (response.statusText === "OK") {
        // Handle successful login, set token, navigate, etc.
        if (isSuperAdmin(response.data)) {
          user.value = response.data;
          // localStorage.setItem('user', JSON.stringify(user.value));
          await router.push(returnUrl.value || '/');
        } else {
          await logout();
          throw new Error(`User ${response.data['username']} is not Superadmin!`);
        }
      } else {
        // Handle failure, show error message
        throw new Error(`Access Denied. Code: ${response.status}`);
      }
    }

    async function logout(returnUrlParam = null) {
      await axios.post(endpoint('public/1/auth/logout/'));
      user.value = null;
      if (returnUrlParam === null) {
        returnUrl.value = '';
      } else {
        returnUrl.value = returnUrlParam;
      }
      localStorage.removeItem('user');
      await router.push('/login');
    }

    async function pollIfLogged(routeComposable) {
      let response;
      try {
        response = await axios.get(endpoint('public/1/auth/myself/'), {
          withCredentials: true,
          timeout: 10000,
        });
      } catch (e) {
        if (e.response && e.response.status !== 403) {
          // Unexpected response code
          console.log(`Unexpected poll User with response code ${e.response.status} and body ${e.response.data}`);
        }
        await logout(routeComposable.path);
        return;
      }
      if (isSuperAdmin(response.data)) {
        polledAndLoggedIn.value = true;
        user.value = response.data;
        // localStorage.setItem('user', JSON.stringify(user.value));
      } else {
        await logout(routeComposable.path);
        throw new Error(`User ${response.data['username']} is not Superadmin!`);
      }
    }

    return { user, returnUrl, login, logout, pollIfLogged, isLogged };
  }
);

